import React from 'react';
import { InputField } from '../../../utility/form';
import LoadingButton from '../../../utility/button/LoadingButton';
import useUnlockAccount from './useUnlockAccount';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SEO from '../../../SEO/Seo';
import { metaContent } from '../../../SEO/metaContent';

const ForgotPassword = () => {
  const { t } = useTranslation();
  const { form, onChange, onSubmit, loading, validate, result, errors } = useUnlockAccount();

  return (<>
    {/* Meta tag */}
    <SEO {...metaContent.unlockAccount} />

    <div className="auth-card mx-auto ">
      <h3 className="text-center fw-bold mb-1">Unlock Account?</h3>
      <div className="text-center" style={{ color: '#7b7b8b', fontSize: '1rem', marginBottom: 20 }}>
        Enter your email address below and we’ll send you a link to unlock your account.
      </div>
      <form onSubmit={onSubmit} noValidate>
        <div className="mb-3">
          <InputField
            label={t('forgotPassword.emailLabel')}
            name="email"
            value={form.email}
            onChange={onChange}
            error={errors.email}
            placeholder={t('forgotPassword.emailPlaceholder')}
            type="email"
          />
        </div>
        <LoadingButton
          type="submit"
          disabled={loading}
          isLoading={loading}
          className="w-100"
        >
          Resend unlock instructions
        </LoadingButton>
      </form>
      <div className="mt-3 text-center">
        <Link
          to="/signin"
          className="btn-link ps-0"
          style={{
            pointerEvents: 'auto',
            color: 'blue',
            cursor: 'pointer',
          }}
        >
          <i className="bi bi-arrow-left"></i>&nbsp;{t('forgotPassword.backToSignIn')}
        </Link>
      </div>
    </div>
  </>
  );
};

export default ForgotPassword;
